import type { SVGProps } from 'react';

export const FeedbackSendMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="12px"
    role="img"
    viewBox="0 0 16.2 12"
    width="16.2px"
    x="0px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    y="0px"
    {...props}
  >
    <title>{'feedback send message'}</title>
    <path
      d="M16.2,10.1l0-8.5c0-0.4-0.1-0.8-0.3-1c0-0.1-0.1-0.1-0.1-0.1c-0.1-0.1-0.3-0.3-0.4-0.3
        c-0.1-0.1-0.3-0.1-0.4-0.1C14.8,0,14.6,0,14.4,0H1.9C1,0,0.6,0.3,0.3,0.6C0.1,0.9,0,1.2,0,1.7v8.4c0,0.2,0,0.3,0,0.4
        C0.1,11,0.5,12,1.9,12h12.6C15.6,12,16.2,11.2,16.2,10.1C16.2,10.2,16.2,10.2,16.2,10.1C16.2,10.2,16.2,10.2,16.2,10.1z M15.2,1.5
        c0,0.1,0,0.1,0,0.2v7.6L10.3,6L15.2,1.5z M14.6,1L9.4,5.7L8.9,6.2c0,0-0.1,0.1-0.1,0.1C8.6,6.4,8.5,6.5,8.3,6.5
        c-0.2,0-0.4,0.1-0.8-0.3L6.9,5.7c0,0,0,0,0,0L1.7,1C1.7,1,14.6,1,14.6,1z M1,1.5L5.9,6L1,9.3V1.7C1,1.6,1,1.5,1,1.5z M14.4,11H1.9
        C1.1,11,1,10.7,1,10.4l5.6-3.8L6.9,7c0.4,0.3,0.8,0.5,1.2,0.5c0.1,0,0.3,0,0.4-0.1C8.8,7.3,9.1,7.2,9.3,7c0,0,0,0,0.1-0.1
        c0,0,0,0,0,0l0.3-0.3l5.6,3.7C15.2,10.7,15.1,11,14.4,11z"
      fill={props.fill}
    />
  </svg>
);
